<div class="field-wrapper" [style.marginBottom]="marginBottom" [ngClass]="{ error: !_disabled && hasError }">
  @if (label) {
    <label class="field-label" [for]="id">{{ label }}</label>
  }

  <div
    class="field-control-wrapper"
    [ngClass]="{
      'pressed-active': !_readonly && _focused,
      disabled: _disabled,
      readonly: _readonly,
      'has-suffix-icon-click': suffixIconName && suffixIconClick?.observers?.length,
    }"
    (click)="_focused || fieldControl.focus(); _disabled || inputClick.emit($event)"
    (mouseenter)="inputMouseEnter.emit($event)"
    (mouseleave)="inputMouseLeave.emit($event)"
  >
    <div class="field-content--left">
      @if (prefixText) {
        <div class="subtext">{{ prefixText }}</div>
      }
      @if (prefixIconName) {
        <i [class]="prefixIconName"></i>
      } @else if (prefixImgUrl) {
        <img [src]="prefixImgUrl" alt="" />
      }
      <input
        #fieldControl
        [id]="id"
        [name]="name"
        [type]="type"
        [value]="value"
        [disabled]="_disabled"
        [readonly]="readonly"
        [placeholder]="placeholder"
        [autocomplete]="autocomplete"
        [attr.inputmode]="inputMode"
        [attr.max]="max"
        [attr.maxLength]="maxLength"
        [attr.min]="min"
        [attr.minLength]="minLength"
        (focus)="onFocusIn($event)"
        (blur)="onFocusOut($event)"
        (input)="onInput($event)"
        (click)="$event.stopPropagation(); inputClick.emit($event)"
      />
    </div>

    @if (suffixText || suffixIconName) {
      <div class="field-content--right" (click)="$event.stopPropagation()">
        @if (suffixText) {
          <div class="subtext" (click)="onSuffixIconClick($event)">{{ suffixText }}</div>
        }

        @if (suffixIconName) {
          <i [class]="suffixIconName" (click)="onSuffixIconClick($event)"></i>
        }
      </div>
    }
  </div>
  @if (!fieldControl.disabled && hasError && errorHint) {
    <div class="field-hint" [class.hintAbsolute]="hintAbsolute">
      {{ errorHint }}
    </div>
  }
</div>
